import moment from 'moment'


export const getDateFormatted = (date) => date ? moment(date, 'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : ''


export const getNormalBody = (data) => ({
  ...data,
  date_from: getDateFormatted(data.date_from),
  date_to: getDateFormatted(data.date_to),
  date_to_guk: getDateFormatted(data.date_to_guk),
  closed: data.closed === '1'
})